<template>
  <div>
    <!-- PC端导航栏 -->
    <PCNavbar v-if="platform === 'web'" />
    
    <!-- 移动端导航栏 -->
    <div v-else class="mobile-navbar">
      <div class="nav-left">
        <router-link to="/home">
          <img :src="config.logo1" alt="慈福" />
        </router-link>
      </div>
      <div style="display: flex; align-items: center;">
        <div class="nav-right">
          <div class="menu-icon" @click="toggleMobileMenu">
            <i class="el-icon-menu"></i>
          </div>
        </div>
        <div class="login">
          <router-link to="/login" class="btn">登录</router-link>
          <router-link to="/register" class="btn">注册</router-link>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <transition name="slide">
      <div class="mobile-menu-overlay" v-show="mobileMenuVisible" @click.self="toggleMobileMenu">
        <div class="mobile-menu-content">
          <div class="menu-header">
            <h3>慈福官网</h3>
            <div class="close-btn" @click="toggleMobileMenu">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="menu-list">
            <router-link to="/home" class="menu-item" @click="toggleMobileMenu">
              <i class="el-icon-house"></i>
              <span>首页</span>
            </router-link>
            <div class="menu-group">
              <div class="menu-title">关于慈福</div>
              <router-link 
                v-for="item in about_cifu" 
                :key="item.id" 
                :to="`/about?type=${item.id}`" 
                class="menu-sub-item"
                @click="toggleMobileMenu"
              >
                {{ item.name }}
              </router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">慈福项目</div>
              <router-link 
                v-for="(item, index) in cateList" 
                :key="index" 
                :to="`/project?type=${index + 1}`" 
                class="menu-sub-item"
                @click="toggleMobileMenu"
              >
                {{ item.title }}
              </router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">爱心捐赠</div>
              <router-link to="/donate?type=1" class="menu-sub-item" @click="toggleMobileMenu">捐款方式</router-link>
              <router-link to="/donate?type=2" class="menu-sub-item" @click="toggleMobileMenu">捐赠记录</router-link>
              <router-link to="/donate?type=3" class="menu-sub-item" @click="toggleMobileMenu">票据申领</router-link>
              <router-link to="/donate?type=4" class="menu-sub-item" @click="toggleMobileMenu">证书申领</router-link>
              <router-link to="/donate?type=5" class="menu-sub-item" @click="toggleMobileMenu">抵扣说明</router-link>
              <router-link v-if="aixin_status == 1" to="/donate?type=6" class="menu-sub-item" @click="toggleMobileMenu">爱心传递</router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">慈福新闻</div>
              <router-link 
                v-for="(item, index) in newsLei" 
                :key="index" 
                :to="`/news?type=${index + 1}`" 
                class="menu-sub-item"
                @click="toggleMobileMenu"
              >
                {{ item.name }}
              </router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">信息公开</div>
              <router-link to="/information?type=5" class="menu-sub-item" @click="toggleMobileMenu">资质证书</router-link>
              <router-link 
                v-for="(item, index) in reportList" 
                :key="index" 
                :to="`/information?type=${item.id}`" 
                class="menu-sub-item"
                @click="toggleMobileMenu"
              >
                {{ item.title }}
              </router-link>
              <router-link to="/information?type=6" class="menu-sub-item" @click="toggleMobileMenu">免税批文</router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">党建专栏</div>
              <router-link 
                v-for="(item, index) in fenlei" 
                :key="index" 
                :to="`/partyBuilding?type=${index + 1}`" 
                class="menu-sub-item"
                @click="toggleMobileMenu"
              >
                {{ item.name }}
              </router-link>
            </div>
            <div class="menu-group">
              <div class="menu-title">加入我们</div>
              <router-link to="/joinUs?type=1" class="menu-sub-item" @click="toggleMobileMenu">人员招聘</router-link>
              <router-link to="/joinUs?type=2" class="menu-sub-item" @click="toggleMobileMenu">志愿者招聘</router-link>
              <router-link to="/joinUs?type=3" class="menu-sub-item" @click="toggleMobileMenu">联系我们</router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <CarouselHome type="banner"/>
    <Datastatistics />
    <ProjectView type="home" style="width: 100%;"/>
    <NewsInfomation type="home" />
    <Information />
    <CooperationCustomer />
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Datastatistics from "@/components/datastatistics/index";
import ProjectView from "@/components/projectView/projectView1";
import NewsInfomation from "@/components/news_infomation/index";
import Information from "@/components/information/information";
import CooperationCustomer from "@/components/cooperation_customer/index";
import Footer from "@/components/footer/index";
import CifuAPI from "@/utils/api";

export default {
  name: "Home",
  components: {
    PCNavbar,
    CarouselHome,
    Datastatistics,
    ProjectView,
    Information,
    CooperationCustomer,
    NewsInfomation,
    Footer,
  },
  data() {
    return {
      mobileMenuVisible: false,
      fenlei: [],
      cateList: [],
      reportList: [],
      aixin_status: 1,
      about_cifu: [],
      newsLei: [],
    };
  },
  computed: {
    ...mapState(["platform", "config"]),
  },
  created() {
    this.$store.dispatch("setMenuActive", "home");
    this.getMenuData();
  },
  mounted() {
    this.$nextTick(() => {
      // 检查是否有partner参数，如果有则滚动到合作伙伴区域
      if (this.$route.query.partner) {
        setTimeout(() => {
          this.scrollToPartners();
        }, 1000);
      }
    });
  },
  
  beforeDestroy() {
    // 恢复背景滚动
    document.body.style.overflow = '';
  },
  methods: {
    async getMenuData() {
      try {
        // 获取党建分类
        const fenleiRes = await CifuAPI.getArticleType({ model_type: "dzb_activity" });
        if (fenleiRes.code == 1) {
          this.fenlei = fenleiRes.data;
        }
        
        // 获取项目分类
        const cateRes = await CifuAPI.getCateList();
        if (cateRes.code == 1) {
          this.cateList = cateRes.data;
        }
        
        // 获取报告类型
        const reportRes = await CifuAPI.getReportType();
        if (reportRes.code == 1) {
          this.reportList = reportRes.data;
        }
        
        // 获取配置信息
        const configRes = await CifuAPI.getConfig();
        if (configRes.code == 1) {
          this.aixin_status = configRes.data.aixin_status;
          this.about_cifu = configRes.data.about_cifu;
        }
        
        // 获取新闻类型
        const newsRes = await CifuAPI.getArticleType({ model_type: "news" });
        if (newsRes.code == 1) {
          this.newsLei = newsRes.data;
        }
      } catch (error) {
        console.error('Error getting menu data:', error);
      }
    },
    
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      // 防止背景滚动
      if (this.mobileMenuVisible) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    
    scrollToPartners() {
      this.$nextTick(() => {
        const partnersElement = document.getElementById("partners");
        if (partnersElement) {
          partnersElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 移动端导航栏样式
.mobile-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #fbce00;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  .nav-left {
    padding-top: 58px;
    img {
      width: 107px;
      height: auto;
    }
  }
  
  .nav-right {
    .menu-icon {
      font-size: 24px;
      color: #663301;
      cursor: pointer;
      padding: 10px;
      
      &:hover {
        color: #d60c18;
      }
    }
  }
}

// 移动端菜单样式
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  
  .mobile-menu-content {
    position: absolute;
    top: 70px;
    right: 0;
    width: 280px;
    height: calc(100vh - 70px);
    background: #fff;
    border-radius: 8px 0 0 8px;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    
    .menu-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #f0f0f0;
      
      h3 {
        margin: 0;
        color: #663301;
        font-size: 18px;
      }
      
      .close-btn {
        font-size: 20px;
        color: #999;
        cursor: pointer;
        padding: 5px;
        
        &:hover {
          color: #d60c18;
        }
      }
    }
    
    .menu-list {
      padding: 0;
      
      .menu-item {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        color: #663301;
        text-decoration: none;
        border-bottom: 1px solid #f5f5f5;
        transition: all 0.3s ease;
        
        i {
          margin-right: 15px;
          font-size: 18px;
        }
        
        &:hover {
          background: #f5f7fa;
          color: #d60c18;
        }
      }
      
      .menu-group {
        .menu-title {
          padding: 15px 20px 10px;
          color: #999;
          font-size: 14px;
          font-weight: bold;
          background: #f9f9f9;
        }
        
        .menu-sub-item {
          display: block;
          padding: 12px 20px 12px 40px;
          color: #663301;
          text-decoration: none;
          border-bottom: 1px solid #f5f5f5;
          font-size: 14px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #f5f7fa;
            color: #d60c18;
          }
        }
      }
    }
  }
}

// 动画效果
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

// 响应式优化
@media screen and (max-width: 480px) {
  .mobile-navbar {
    height: 60px;
    padding: 0 15px;
    
    .nav-left img {
      width: 60px;
    }
    
    .nav-right .menu-icon {
      font-size: 20px;
    }
  }
  
  .mobile-menu-overlay .mobile-menu-content {
    top: 60px;
    width: 260px;
    
    .menu-header {
      padding: 15px;
      
      h3 {
        font-size: 16px;
      }
    }
    
    .menu-list {
      .menu-item {
        padding: 12px 15px;
        font-size: 14px;
      }
      
      .menu-group {
        .menu-title {
          padding: 12px 15px 8px;
          font-size: 13px;
        }
        
        .menu-sub-item {
          padding: 10px 15px 10px 35px;
          font-size: 13px;
        }
      }
    }
  }
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 24px;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 42px;
    background: #fffae5;
    border: none;
    border-radius: 40px;
    font-size: 16px;
    color: #663301;
    & + .btn {
      margin-left: 10px;
    }
  }
}
</style>
